module.exports = __webpack_public_path__ + "static/media/external-link.03979156.svg";